<template>
  <b-container fluid>
    <TopBar id="top-bar"></TopBar>
    <AssociationModule class="block_import" :list_modules="lists.modules" :key="module.id" :old_id_module="module.id" @changeSelectedModule="changeSelectedModule"></AssociationModule>

    <ImportGMCAP
      class="block_import"
      v-if="module.source_export && lists.exports.length > 0"
      :list_exports="lists.exports"
      :old_export_url="module.url_export"
      :old_source_export="module.source_export"
      @changeSelectedExport="setExportFromServer"
      @uploadExport="setExportFromDesktop"
    ></ImportGMCAP>

    <InformationsSupplementaires :module_infos="module.informations" :list_diplomes="lists.diplomes" @changeSelectedDiplome="setDiplome" @uploadFlyer="setFlyer" class="block_import"></InformationsSupplementaires>

    <AdditionnalLinks class="block_import" :additionnal_links="module.informations.additionnal_links"></AdditionnalLinks>

    <AdditionnalFiles class="block_import" :additionnal_files="module.informations.additionnal_files" @uploadAdditionnalFiles="setAdditionnalFiles"></AdditionnalFiles>
    <RassemblementCourse v-if="raw_resultats.length > 0" :raw_rassemblement="module.informations.rassemblements_course" :raw_resultats="raw_resultats" class="block_import" @updateRassemblement="setRassemblementCourse"></RassemblementCourse>
    <ChallengeCourse v-if="raw_resultats.length > 0" :raw_challenges="module.informations.challenges" :raw_resultats="raw_resultats" class="block_import" @updateChallenges="setChallenges"></ChallengeCourse>
    <ChallengeCourseEquipe v-if="raw_resultats.length > 0" :raw_challenges_equipe="module.informations.challenges_equipe" :raw_resultats="raw_resultats" class="block_import" @updateChallenges="setChallengesEquipe"></ChallengeCourseEquipe>
    <CourseCumulInter v-if="raw_resultats.length > 0" :raw_courses_cumul="module.informations.courses_cumul" :raw_resultats="raw_resultats" class="block_import" @updateCoursesCumul="setCoursesCumul"></CourseCumulInter>
    <CourseCumulInterEquipe
      v-if="raw_resultats.length > 0"
      :raw_courses_cumul_equipe="module.informations.courses_cumul_equipe"
      :raw_resultats="raw_resultats"
      class="block_import"
      @updateCoursesCumulEquipe="setCoursesCumulEquipe"
    ></CourseCumulInterEquipe>

    <Formater v-if="raw_resultats.length > 0" :old_passages_inter="passages_inter" :old_course_formater="champs_speciaux" :raw_resultats="raw_resultats" @launchUpload="launchUpload"></Formater>
    <FullScreenLoading v-if="loading" action="Envoi des résultats en cours"></FullScreenLoading>
    <FullScreenConfirmation v-if="confirmation.status" :id="confirmation.id"></FullScreenConfirmation>
  </b-container>
</template>

<script>
import AssociationModule from "@/component/Import/AssociationModule.vue";
import ImportGMCAP from "@/component/Import/ImportGMCAP.vue";
import InformationsSupplementaires from "@/component/Import/InformationsSupplementaires.vue";
import RassemblementCourse from "@/component/Import/RassemblementCourse.vue";
import ChallengeCourse from "@/component/Import/ChallengeCourse.vue";
import ChallengeCourseEquipe from "@/component/Import/ChallengeCourseEquipe.vue";
import CourseCumulInter from "@/component/Import/CourseCumulInter.vue";
import CourseCumulInterEquipe from "@/component/Import/CourseCumulInterEquipe.vue";
import Formater from "@/component/Import/Formater.vue";
import AdditionnalFiles from "@/component/Import/AdditionnalFiles.vue";
import AdditionnalLinks from "@/component/Import/AdditionnalLinks.vue";
import FullScreenLoading from "@/component/FullScreenLoading";
import FullScreenConfirmation from "@/component/Import/FullScreenConfirmation";
import TopBar from "@/component/Import/TopBar";
import Axios from "axios";
export default {
  components: {
    AssociationModule,
    ImportGMCAP,
    InformationsSupplementaires,
    AdditionnalFiles,
    AdditionnalLinks,
    Formater,
    FullScreenLoading,
    FullScreenConfirmation,
    TopBar,
    ChallengeCourse,
    ChallengeCourseEquipe,
    CourseCumulInter,
    CourseCumulInterEquipe,
    RassemblementCourse,
  },

  data() {
    return {
      module: {
        id_module_resultat: 0,
        id: 0,
        informations: {
          nom: "",
          date_epreuve: "",
          ville_competition: "",
          code_ville_competition: "",
          type_competition: "",
          annee_epreuve: "",
          url_flyer: "",
          diplome: 0,
          additionnal_links: [{ title: "", url: "" }],
          additionnal_files: [{ title: "", url: "" }],
          rassemblements_course: [],
          challenges: [],
          challenges_equipe: [],
          courses_cumul: [],
          courses_cumul_equipe: [],
        },
        url_export: "",
        source_export: "",
      },
      lists: {
        modules: [],
        exports: [],
      },
      raw_resultats: [],
      champs_speciaux: [],
      passages_inter: [],
      loading: false,
      confirmation: { status: false, id: 0 },
    };
  },
  methods: {
    pausecomp(millis) {
      var date = new Date();
      var curDate = null;
      do {
        curDate = new Date();
      } while (curDate - date < millis);
    },
    launchUpload(c) {
      var _this = this;
      this.loading = true;
      this.module.courses = c;
      var data = {
        action: "editDesktopResults",
        module: this.module,
      };
      if (this.module.source_export === "desktop") {
        data.raw_resultats = this.raw_resultats;
      }
      Axios.post(this.$store.getters.base_url + "/import/results/edit.php", data).then(function (response) {
        _this.pausecomp(1000);
        _this.loading = false;
        if (parseInt(response.data) > 0) {
          _this.confirmation.status = true;
          _this.confirmation.id = parseInt(response.data);
        }
      });
    },
    /* Au changement d'association de module */
    changeSelectedModule(e) {
      this.module.id = e;
      this.setUrlFlyer();
    },

    setUrlFlyer() {
      for (var i = 0; i < this.lists.modules.length; i++) {
        if (this.module.id === this.lists.modules[i].value) {
          var base = this.lists.modules[i].text.split(" | ")[0];
          this.module.informations.url_flyer = "https://sportips.fr/" + base + "/img/flyer.jpg";
        }
      }
    },

    /* Si l'export est selectionné depuis ceux disponible sur le server */
    setExportFromServer(e) {
      this.module.url_export = "https://sportips.fr/live/export_live/Export_GMCAP/" + e;
      this.module.source_export = "server";
      var _this = this;

      var data = new FormData();
      data.append("url", this.module.url_export);
      Axios.post(this.$store.getters.base_url + "/import/export/get.php", data).then(function (response) {
        _this.raw_resultats = response.data;
      });
    },

    /* Si l'export est chargé depuis le PC */
    setExportFromDesktop(e) {
      this.module.url_export = "https://sportips.fr/plateformeResultats/gmcap/" + e.filename;
      this.raw_resultats = e.content.data;
      this.module.source_export = "desktop";
    },
    /* Si un diplome est selectionné */
    setDiplome(e) {
      this.module.informations.diplome = e;
    },
    /* Si un flyer est uploadé */
    setFlyer(e) {
      this.module.informations.url_flyer = e;
    },

    /* Si un fichier supplémentaire est uploadé */
    setAdditionnalFiles(e) {
      this.module.informations.additionnal_files[e.index].url = e.url;
    },

    setChallenges(e) {
      this.module.informations.challenges = e;
    },
    setChallengesEquipe(e) {
      this.module.informations.challenges_equipe = e;
    },
    setCoursesCumul(e) {
      this.module.informations.courses_cumul = e;
    },
    setCoursesCumulEquipe(e) {
      this.module.informations.courses_cumul_equipe = e;
    },
    setRassemblementCourse(e) {
      this.module.informations.rassemblements_course = e;
    },

    /* Récupère la liste des modules et exports récents pour remplir les selects */
    fetchLists() {
      var _this = this;
      Axios.get(this.$store.getters.base_url + "/import/modules/get.php?action=select").then(function (response) {
        _this.lists.modules = response.data;
      });
      Axios.get(this.$store.getters.base_url + "/import/exports/get.php").then(function (response) {
        _this.lists.exports = response.data;
      });
      Axios.get(this.$store.getters.base_url + "/import/diplomes/get.php?action=select").then(function (response) {
        _this.lists.diplomes = response.data;
      });
    },

    fetchModule() {
      var _this = this;
      Axios.get(this.$store.getters.base_url + "/import/results/get.php?id=" + this.$route.query.id).then(function (response) {
        _this.module.id_module_resultat = _this.$route.query.id;
        _this.module.informations.nom = response.data.nom_epreuve;
        _this.module.informations.date_epreuve = response.data.date_epreuve;
        _this.module.informations.ville_competition = response.data.ville_competition;
        _this.module.informations.code_ville_competition = response.data.code_ville_competition;
        _this.module.informations.type_competition = response.data.type_competition;
        _this.module.informations.annee_epreuve = response.data.annee_epreuve;
        _this.module.informations.url_flyer = response.data.url_flyer;
        _this.module.informations.additionnal_links = response.data.additionnal_links;
        _this.module.informations.additionnal_files = response.data.additionnal_files;
        _this.module.informations.diplome = response.data.id_diplome;
        _this.module.id = response.data.id_module;
        _this.champs_speciaux = response.data.champs_speciaux;
        _this.passages_inter = response.data.passages_inter;
        console.log(response.data);
        _this.module.informations.rassemblements_course = response.data.rassemblements_course;
        _this.module.informations.challenges = response.data.challenges;
        _this.module.informations.challenges_equipe = response.data.challenges_equipe;
        _this.module.informations.courses_cumul = response.data.courses_cumul;
        _this.module.informations.courses_cumul_equipe = response.data.courses_cumul_equipe;
        _this.module.url_export = response.data.url_export;
        _this.module.source_export = response.data.source_export;
        _this.$forceUpdate();
      });
    },
  },
  watch: {
    raw_resultats() {
      for (var i = 0; i < this.raw_resultats.length; i++) {
        if (this.raw_resultats[i]["Competition"] != "") {
          var first_row = this.raw_resultats[i];
          this.module.informations.nom = first_row["Competition"];
          this.module.informations.date_epreuve = first_row["Date Compet."];
          this.module.informations.ville_competition = first_row["Ville Compet."];
          this.module.informations.code_ville_competition = first_row["Code Ville Compet."];
          this.module.informations.type_competition = first_row["Type Compet."];
          this.module.informations.annee_epreuve = first_row["Date Compet."].slice(-4);
          return;
        }
      }
    },
  },
  created() {
    if (this.$route.query.id) {
      this.fetchModule();
    }

    this.fetchLists();
  },
};
</script>

<style>
.block_import {
  font-size: 12px;
  background-color: #e2e2e2;
  border: 1px solid #999;
  border-radius: 3px;
  margin: 15px 5px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.block_import .col,
.block_import p {
  text-align: left;
}
.block_import p {
  margin-bottom: 0;
  line-height: 38px;
  font-weight: bold;
}

.block_import legend {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/view/Edit.vue